export enum CloseModalType {
  Close = 'Close',
  Skip = 'Skip',
  Finish = 'Finish',
}
